/**
 * Centralized token storage.
 *
 * SECURITY NOTE: Tokens are currently stored in localStorage, which is
 * vulnerable to XSS exfiltration. When the backend supports it, migrate
 * to HTTP-only secure cookies for refresh tokens at minimum.
 *
 * By centralizing here, all token read/write/clear goes through one place,
 * making a future migration straightforward.
 */

const TOKEN_KEYS = {
  access: "access_token",
  id: "id_token",
  refresh: "refresh_token",
};

export const tokenStorage = {
  getAccessToken() {
    return localStorage.getItem(TOKEN_KEYS.access);
  },

  getRefreshToken() {
    return localStorage.getItem(TOKEN_KEYS.refresh);
  },

  getIdToken() {
    return localStorage.getItem(TOKEN_KEYS.id);
  },

  setTokens({ access_token, id_token, refresh_token }) {
    if (access_token) localStorage.setItem(TOKEN_KEYS.access, access_token);
    if (id_token) localStorage.setItem(TOKEN_KEYS.id, id_token);
    if (refresh_token) localStorage.setItem(TOKEN_KEYS.refresh, refresh_token);
  },

  clearAll() {
    localStorage.removeItem(TOKEN_KEYS.access);
    localStorage.removeItem(TOKEN_KEYS.id);
    localStorage.removeItem(TOKEN_KEYS.refresh);
  },
};
